import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ForDoctors = () => {
  const [selectedCity, setSelectedCity] = useState('');

  const distributors = [
    { city: '北京', contact: '张经理', phone: '010-12345678', email: 'beijing@mirokids.com' },
    { city: '上海', contact: '李经理', phone: '021-87654321', email: 'shanghai@mirokids.com' },
    { city: '广州', contact: '王经理', phone: '020-98765432', email: 'guangzhou@mirokids.com' },
    { city: '深圳', contact: '刘经理', phone: '0755-23456789', email: 'shenzhen@mirokids.com' },
    { city: '成都', contact: '陈经理', phone: '028-34567890', email: 'chengdu@mirokids.com' },
    { city: '杭州', contact: '赵经理', phone: '0571-45678901', email: 'hangzhou@mirokids.com' }
  ];

  const filteredDistributors = selectedCity 
    ? distributors.filter(d => d.city.includes(selectedCity))
    : distributors;

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-600 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-64 h-64 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6 leading-tight">
                携手Mirókids<br />开启数字化正畸新时代
              </h1>
              <p className="text-xl text-white/90 mb-8 leading-relaxed">
                为您提供完整的儿童隐形矫治解决方案，包括AI智能排牙系统、专业培训支持、高效ERP管理平台，助力您的诊所业务升级
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full">
                  <i className="ri-check-line text-2xl"></i>
                  <span className="font-medium">零加盟费</span>
                </div>
                <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full">
                  <i className="ri-check-line text-2xl"></i>
                  <span className="font-medium">全程培训</span>
                </div>
                <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full">
                  <i className="ri-check-line text-2xl"></i>
                  <span className="font-medium">技术支持</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20">
              <div className="text-center mb-6">
                <h3 className="text-3xl font-bold mb-2">已有账号？</h3>
                <p className="text-white/80">立即登录医生工作台</p>
              </div>
              <button className="w-full bg-white text-blue-600 py-4 rounded-xl text-lg font-bold hover:bg-blue-50 transition-all duration-300 shadow-xl hover:shadow-2xl mb-4 whitespace-nowrap">
                <i className="ri-login-box-line mr-2"></i>
                医生端登录
              </button>
              <p className="text-center text-white/70 text-sm">
                首次使用？请先提交合作申请
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              为什么选择与我们合作
            </h2>
            <p className="text-xl text-gray-600">
              全方位赋能，让您的正畸业务更专业、更高效
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-brain-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">AI智能排牙系统</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                基于深度学习的智能排牙算法，自动生成精准矫治方案，大幅提升诊断效率
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>3分钟完成方案设计</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>99%精准度保障</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-graduation-cap-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">专业培训体系</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                从入门到精通，提供系统化培训课程和实操指导，快速掌握儿童隐形矫治技术
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>线上+线下培训</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>专家一对一指导</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-dashboard-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">ERP管理平台</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                一站式患者管理、订单跟踪、数据分析，让诊所运营更智能化
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>患者全生命周期管理</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>实时数据可视化</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-customer-service-2-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">7×24技术支持</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                专业技术团队随时待命，解决您在使用过程中遇到的任何问题
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>在线客服即时响应</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>专属技术顾问</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-medal-line text-3xl text-red-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">品牌赋能</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                共享品牌影响力，获得官网展示、营销物料支持，提升诊所知名度
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>官网诊所展示</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>营销物料支持</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-yellow-100 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-line-chart-line text-3xl text-yellow-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">持续收益</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                合理的利润分配机制，让您的每一份付出都获得应有的回报
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>透明价格体系</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>阶梯式返点激励</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section - Replacing Application Form */}
      <section className="py-20 px-6 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              联系我们
            </h2>
            <p className="text-xl text-gray-600">
              欢迎咨询合作事宜，我们的团队随时为您服务
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            {/* Customer Service */}
            <div className="bg-white rounded-3xl shadow-2xl p-10">
              <div className="text-center mb-8">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-2-line text-4xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">联系客服</h3>
                <p className="text-gray-600">我们的客服团队将为您提供专业咨询</p>
              </div>

              <div className="space-y-6">
                <div className="flex items-center gap-4 p-4 bg-blue-50 rounded-xl">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-600">客服热线</div>
                    <a href="tel:400-123-4567" className="text-xl font-bold text-blue-600 hover:underline">
                      400-123-4567
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4 p-4 bg-blue-50 rounded-xl">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className="ri-mail-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-600">商务邮箱</div>
                    <a href="mailto:business@mirokids.com" className="text-xl font-bold text-blue-600 hover:underline">
                      business@mirokids.com
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4 p-4 bg-blue-50 rounded-xl">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className="ri-wechat-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-600">微信客服</div>
                    <div className="text-xl font-bold text-gray-900">Mirokids_Service</div>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 bg-blue-50 rounded-xl">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className="ri-time-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-600">服务时间</div>
                    <div className="text-lg font-bold text-gray-900">周一至周五 9:00-18:00</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Local Distributors */}
            <div className="bg-white rounded-3xl shadow-2xl p-10">
              <div className="text-center mb-8">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-user-line text-4xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">本地经销商</h3>
                <p className="text-gray-600">联系您所在地区的经销商获取支持</p>
              </div>

              <div className="mb-6">
                <div className="relative">
                  <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-xl text-gray-400"></i>
                  <input
                    type="text"
                    placeholder="搜索城市..."
                    value={selectedCity}
                    onChange={(e) => setSelectedCity(e.target.value)}
                    className="w-full pl-12 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-600 focus:outline-none transition-colors"
                  />
                </div>
              </div>

              <div className="space-y-4 max-h-96 overflow-y-auto pr-2">
                {filteredDistributors.map((distributor, index) => (
                  <div key={index} className="p-4 bg-gray-50 rounded-xl hover:bg-blue-50 transition-colors">
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        <h4 className="text-lg font-bold text-gray-900">{distributor.city}</h4>
                        <p className="text-sm text-gray-600">{distributor.contact}</p>
                      </div>
                      <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-medium">
                        认证经销商
                      </span>
                    </div>
                    <div className="space-y-2">
                      <a href={`tel:${distributor.phone}`} className="flex items-center gap-2 text-blue-600 hover:underline">
                        <i className="ri-phone-line"></i>
                        <span>{distributor.phone}</span>
                      </a>
                      <a href={`mailto:${distributor.email}`} className="flex items-center gap-2 text-blue-600 hover:underline">
                        <i className="ri-mail-line"></i>
                        <span className="text-sm">{distributor.email}</span>
                      </a>
                    </div>
                  </div>
                ))}

                {filteredDistributors.length === 0 && (
                  <div className="text-center py-8">
                    <i className="ri-map-pin-line text-4xl text-gray-300 mb-2"></i>
                    <p className="text-gray-500">未找到相关城市</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-3xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">需要更多信息？</h3>
            <p className="text-blue-100 mb-6">
              我们的商务团队将为您提供详细的合作方案和产品资料
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a 
                href="tel:400-123-4567"
                className="whitespace-nowrap bg-white text-blue-600 hover:bg-blue-50 px-8 py-3 rounded-full font-bold transition-colors shadow-lg cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-phone-line"></i>
                立即致电
              </a>
              <a 
                href="mailto:business@mirokids.com"
                className="whitespace-nowrap bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-8 py-3 rounded-full font-bold border-2 border-white/30 transition-colors cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-mail-line"></i>
                发送邮件
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 px-6 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold mb-2">500+</div>
              <div className="text-xl text-white/80">合作诊所</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">1000+</div>
              <div className="text-xl text-white/80">认证医生</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">50000+</div>
              <div className="text-xl text-white/80">成功案例</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">98%</div>
              <div className="text-xl text-white/80">满意度</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ForDoctors;
